import { render, staticRenderFns } from "./SylvanaWaiting2.vue?vue&type=template&id=5c9cb035&"
import script from "./SylvanaWaiting2.vue?vue&type=script&lang=ts&"
export * from "./SylvanaWaiting2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports